export default "__VITE_ASSET__CQNLs6f8__"